import { object, string } from "../../../types/_types";

export const DistributionChannelEmailNotification = object({
	sendFrom: string(),
	sendTo: string(),
	ccTo: string(),
	bccTo: string(),
	subject: string(),
	messageTemplate: string(),
});
